/**
 * Common actions
 *
 */
export const SPINNER_ON = 'SPINNER_ON';
export const SPINNER_OFF = 'SPINNER_OFF';
export const SPINNER_SMALL = 'SPINNER_SMALL';
export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const SET_LANGUAGES = 'SET_LANGUAGES';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const SET_SCREEN_NOTIFICATION = 'SET_SCREEN_NOTIFICATION';
export const SET_FORM_ERROR = 'SET_FORM_ERROR';
export const SEND_SLACK_NOTIFICATION = 'SEND_SLACK_NOTIFICATION';
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
export const SET_WINDOW_DIMENSIONS = 'SET_WINDOW_DIMENSIONS';
